import { Fragment } from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { renderRichText } from "../richText";
import {
  ContactLabel,
  ContactTable,
  ContactValue,
  Header,
  List,
  ListItem,
  MetaItem,
  MetaLabel,
  MetaList,
  Section,
  SectionTitle,
  Subtitle,
  Text,
  Title,
  Wrapper,
} from "./style";

/* Тексты информационных страниц ведутся только на русском и английском, остальные языки показывают английскую версию. */
const DEFAULT_LANGUAGE = "en";

const renderContactValue = row =>
  row.href ? (
    <a href={row.href}>{row.value}</a>
  ) : (
    renderRichText(row.value)
  );

const renderBlock = (block, index) => {
  if (block.type === "list") {
    return (
      <List key={`block-${index}`}>
        {block.items.map((item, itemIndex) => (
          <ListItem key={`item-${itemIndex}`}>{renderRichText(item)}</ListItem>
        ))}
      </List>
    );
  }

  if (block.type === "table") {
    return (
      <ContactTable key={`block-${index}`}>
        {block.rows.map(row => (
          <Fragment key={row.label}>
            <ContactLabel>{row.label}</ContactLabel>
            <ContactValue>{renderContactValue(row)}</ContactValue>
          </Fragment>
        ))}
      </ContactTable>
    );
  }

  return <Text key={`block-${index}`}>{renderRichText(block.text)}</Text>;
};

export const InfoDocumentComponent = ({ content }) => {
  const { i18n } = useTranslation();

  const language = String(i18n.language || "").slice(0, 2).toLowerCase();
  const doc = content[language] || content[DEFAULT_LANGUAGE];

  return (
    <Wrapper>
      <Header>
        <Title>{doc.title}</Title>

        {!!doc.subtitle && <Subtitle>{doc.subtitle}</Subtitle>}

        {!!doc.meta?.length && (
          <MetaList>
            {doc.meta.map(item => (
              <MetaItem key={item.label}>
                <MetaLabel>{`${item.label}: `}</MetaLabel>
                {renderRichText(item.value)}
              </MetaItem>
            ))}
          </MetaList>
        )}
      </Header>

      {!!doc.intro?.length && (
        <Section>
          {doc.intro.map((text, index) => (
            <Text key={`intro-${index}`}>{renderRichText(text)}</Text>
          ))}
        </Section>
      )}

      {doc.sections.map((section, index) => (
        <Section key={section.title}>
          <SectionTitle>{`${index + 1}. ${section.title}`}</SectionTitle>
          {section.blocks.map(renderBlock)}
        </Section>
      ))}
    </Wrapper>
  );
};

InfoDocumentComponent.propTypes = {
  content: PropTypes.object.isRequired,
};
